export const authEndpoints = {
    forgotPassword: "/api/auth/forgot-password",
    login: "/api/auth/login",
    logout: "/api/auth/logout",
    me: "/api/auth/me",
    refresh: "/api/auth/refresh",
    resetPassword: "/api/auth/reset-password",
} as const;
